<div fxLayout="row" fxLayoutAlign="start center" [class.bg-primary-2]="entry.selected">
  <mat-list-item matRippleDisabled class="cursor-pointer truncate" (click)="select.emit(entry)">
    <mat-radio-button
      [labelPosition]="'after'"
      class="w-full mat-checkbox-flex mat-checkbox-radio"
      (click)="$event.preventDefault()"
      color="primary"
      [checked]="entry.selected"
      [name]="entry.id"
      tabindex="0"
    >
      <span class="truncate"> {{ entry.name }} </span>
    </mat-radio-button>
  </mat-list-item>
  <ng-container *ngTemplateOutlet="customMenu ? customMenu : defaultMenu; context: { $implicit: entry }"></ng-container>
</div>
<ng-template #defaultMenu></ng-template>
